function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { format, differenceInDays, add, getUnixTime, subDays } from 'date-fns';
import { Link } from 'react-router-dom';
import { Flex } from '@signicat/designi/components/layout';
import { Table, Thead, Tbody, Td } from '@signicat/designi/components/tables';
import { Icon } from '@signicat/designi/components/icons';
import { Placeholder } from '@signicat/designi/components/text';
import { CustomPagination } from '@signicat/designi/components/pagination';
import { media } from '@signicat/designi/helpers/responsive';
import { Spinner } from '@signicat/designi/components/loaders';
import { Tooltip } from '@signicat/designi/components/overlays';
import { t } from "../helpers/i18n";
import sort from "../helpers/sort";
import getRecipientName from "../helpers/signer";
import SignOrderExpanded from "./SignOrderExpanded";
import SignOrderRestore from "./SignOrderRestore";
import { orderStatuses } from "../constants/signature";
import { orders as ordersActions } from "../store/actions";
var Status = styled('span').withConfig({
  displayName: "SignOrdersList__Status",
  componentId: "sc-ui6to9-0"
})(["display:inline-block;height:100%;background-color:", ";border-radius:4px;text-transform:uppercase;color:#fff;font-size:12px;font-weight:900;height:20px;padding:3px 6px;letter-spacing:0.4px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;max-width:100%;vertical-align:middle;"], function (props) {
  switch (props.status) {
    case 'draft':
    case 'partially_signed':
    case 'sent':
    case 'sending_queued':
      return '#565656';
    case 'rejected':
    case 'canceled':
    case 'deleted':
    case 'expired':
      return '#f60000';
    case 'sending_error':
      return '#f60000';
    case 'signed':
      return '#2db47d';
    default:
      return '#565656';
  }
});
var TableContainer = styled(Flex).withConfig({
  displayName: "SignOrdersList__TableContainer",
  componentId: "sc-ui6to9-1"
})(["margin-bottom:48px;position:relative;"]);
var StyledTh = styled('th').withConfig({
  displayName: "SignOrdersList__StyledTh",
  componentId: "sc-ui6to9-2"
})(["cursor:pointer;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"]);
var StyledTd = styled(Td).withConfig({
  displayName: "SignOrdersList__StyledTd",
  componentId: "sc-ui6to9-3"
})(["white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"]);
var StyledTable = styled(Table).withConfig({
  displayName: "SignOrdersList__StyledTable",
  componentId: "sc-ui6to9-4"
})(["table-layout:fixed;"]);
var SpinnerContainer = styled('div').withConfig({
  displayName: "SignOrdersList__SpinnerContainer",
  componentId: "sc-ui6to9-5"
})(["display:", ";position:absolute;width:100%;height:100%;justify-content:center;align-items:center;background-color:#00000010;cursor:wait;"], function (props) {
  return props.isLoading ? 'flex' : 'none';
});
var SortIcon = function SortIcon(props) {
  var desc = props.desc;
  var name = desc ? 'descending' : 'ascending';
  return /*#__PURE__*/React.createElement(Icon, {
    size: "sm",
    name: name
  });
};
var SignOrdersList = function SignOrdersList(props) {
  var dispatch = useDispatch();
  var filters = props.filters;
  var list = useSelector(function (state) {
    return state.orders.data;
  });
  var total = useSelector(function (state) {
    return state.orders.total;
  });
  var currentFilter = useSelector(function (state) {
    return state.orders.filter;
  });
  var isLoading = useSelector(function (state) {
    return state.orders.isLoading;
  });
  var settings = useSelector(function (state) {
    return state.module.settings;
  });
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    expandedOrder = _useState2[0],
    setExpandedOrder = _useState2[1];
  var _useState3 = useState({
      field: 'created',
      desc: true
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    sortingField = _useState4[0],
    setSortingField = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    restoreOrder = _useState6[0],
    setRestoreOrder = _useState6[1];
  var _useState7 = useState(20),
    _useState8 = _slicedToArray(_useState7, 1),
    pageSize = _useState8[0];
  var _useState9 = useState(1),
    _useState10 = _slicedToArray(_useState9, 2),
    currentPage = _useState10[0],
    setCurrentPage = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    paginated = _useState12[0],
    setPaginated = _useState12[1];
  var totalPages = Math.ceil(total / pageSize);
  var handleSortClick = function handleSortClick(field) {
    var desc = field === sortingField.field ? !sortingField.desc : true;
    setSortingField({
      field: field,
      desc: desc
    });
  };
  var handleExpandOrderClick = function handleExpandOrderClick(id) {
    return function () {
      setExpandedOrder(id === expandedOrder ? null : id);
    };
  };
  var handleRestoreClick = function handleRestoreClick(order) {
    setRestoreOrder(order);
  };
  var formatDate = function formatDate(rawDate, pattern) {
    if (!rawDate) return;
    return format(new Date(rawDate), pattern);
  };
  var _settings$signature = settings.signature,
    autoDeleteSignOrdersAfterDays = _settings$signature.autoDeleteSignOrdersAfterDays,
    autoDeleteDraftsAfterDays = _settings$signature.autoDeleteDraftsAfterDays;
  var getExpirationDate = function getExpirationDate(order) {
    var date = function date() {
      switch (order.status) {
        case 'signed':
          return add(new Date(order.metaData.lastSignature), {
            days: autoDeleteSignOrdersAfterDays
          });
        case 'expired':
          return add(new Date(order.metaData.expires), {
            days: autoDeleteSignOrdersAfterDays
          });
        case 'draft':
          return add(new Date(order.metaData.created), {
            days: autoDeleteDraftsAfterDays
          });
        default:
          return null;
      }
    };
    var result = date();
    if (!result) return;
    var formattedDate = formatDate(result, 'dd.MM.yyyy  HH:mm');
    var day = formatDate(result, 'eeee');
    return "".concat(t(day.toLowerCase()), ", ").concat(formattedDate);
  };
  var deleteWarningAdvance = 7;
  var getOrderAge = function getOrderAge(order) {
    switch (order.status) {
      case 'signed':
        return differenceInDays(new Date(), new Date(order.metaData.lastSignature));
      case 'expired':
        return differenceInDays(new Date(), new Date(order.metaData.expires));
      case 'draft':
        return differenceInDays(new Date(), new Date(order.metaData.created));
      default:
        return 0;
    }
  };
  var getExpireDaysLeft = function getExpireDaysLeft(order) {
    if (!['signed', 'draft', 'expired'].includes(order.status)) return;
    return ['signed', 'expired'].includes(order.status) ? autoDeleteSignOrdersAfterDays - getOrderAge(order) : autoDeleteDraftsAfterDays - getOrderAge(order);
  };
  var isOrderExpiring = function isOrderExpiring(order) {
    var daysLeft = getExpireDaysLeft(order);
    return ['signed', 'draft', 'expired'].includes(order.status) && daysLeft <= deleteWarningAdvance && daysLeft > 0;
  };
  var isOrderExpired = function isOrderExpired(order) {
    var daysLeft = getExpireDaysLeft(order);
    return ['signed', 'draft', 'expired'].includes(order.status) && daysLeft <= 0;
  };
  var fetchList = function fetchList(page) {
    var filter = filters[0];
    if (filter.id === 'queued_for_removal') {
      var signedBefore = getUnixTime(subDays(new Date(), autoDeleteSignOrdersAfterDays - deleteWarningAdvance));
      var createdBefore = getUnixTime(subDays(new Date(), autoDeleteDraftsAfterDays - deleteWarningAdvance));
      dispatch(ordersActions.getList(page || 0, filter, sortingField, null, createdBefore, signedBefore));
    } else dispatch(ordersActions.getList(page || 0, filter, sortingField));
  };
  var handleChangePage = function handleChangePage(page) {
    if (page === currentPage) {
      return;
    }
    setCurrentPage(page);
    fetchList((page - 1) * 20);
  };
  useEffect(function () {
    var filter = filters[0];
    if (!currentFilter || currentFilter.id === filter.id && currentFilter.searchTerm === filter.searchTerm) {
      return;
    }
    setCurrentPage(1);
    fetchList();
  }, [filters]);
  useEffect(function () {
    setExpandedOrder(null);
  }, [filters, currentPage, sortingField]);
  useEffect(function () {
    fetchList();
  }, [sortingField]);
  useEffect(function () {
    setPaginated(list);
  }, [filters, list]);
  var getOrderIcon = function getOrderIcon(order) {
    // if (currentFilter.id !== 'deleted') {
    if (order.status === 'draft') {
      return /*#__PURE__*/React.createElement(Link, {
        to: "/signature/create/".concat(order.id)
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "edit",
        size: "sm",
        color: "#565656"
      }));
    }
    return /*#__PURE__*/React.createElement(Icon, {
      name: "edit",
      size: "sm",
      color: "#565656",
      style: {
        opacity: '50%',
        cursor: 'default'
      }
    });
    // }
    // return <Icon
    //   onClick={() => handleRestoreClick(order)}
    //   name="restorePage"
    //   size="sm"
    //   color="#565656"
    // />
  };
  var closeRestoreOrder = function closeRestoreOrder(restored) {
    if (restored) {
      dispatch(ordersActions.getById(restoreOrder.id));
    }
    setRestoreOrder(null);
  };
  var getOrderTitle = function getOrderTitle(order) {
    return /*#__PURE__*/React.createElement("span", null, order.metaData.title ? order.metaData.title : /*#__PURE__*/React.createElement(Placeholder, null, t('signorder_placeholder_title_untitled')));
  };
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(SpinnerContainer, {
    isLoading: isLoading
  }, /*#__PURE__*/React.createElement(Spinner, {
    fullscreen: true
  })), /*#__PURE__*/React.createElement(StyledTable, null, /*#__PURE__*/React.createElement(Thead, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(StyledTh, {
    onClick: function onClick() {
      return handleSortClick('title');
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    style: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  }, t('signorders_list_th_title'), sortingField.field === 'title' ? /*#__PURE__*/React.createElement(SortIcon, {
    desc: sortingField.desc
  }) : null)), media.matches.tablet.and('up') ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(StyledTh, {
    style: {
      width: '5%'
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "document",
    size: "sm"
  }), sortingField.field === 'documents' ? /*#__PURE__*/React.createElement(SortIcon, {
    desc: sortingField.desc
  }) : null)), /*#__PURE__*/React.createElement(StyledTh, {
    style: {
      width: '5%'
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "attachment",
    size: "sm"
  }), sortingField.field === 'attachments' ? /*#__PURE__*/React.createElement(SortIcon, {
    desc: sortingField.desc
  }) : null))) : null, media.matches.tablet.and('up') ? /*#__PURE__*/React.createElement("th", null, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    style: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  }, t('signorders_list_th_recipients'))) : /*#__PURE__*/React.createElement(StyledTh, {
    style: {
      width: '40px'
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "person",
    size: "sm"
  }))), /*#__PURE__*/React.createElement(StyledTh, {
    onClick: function onClick() {
      return handleSortClick('status');
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, t('signorders_list_th_status'), sortingField.field === 'status' ? /*#__PURE__*/React.createElement(SortIcon, {
    desc: sortingField.desc
  }) : null)), media.matches.tablet.and('up') ? /*#__PURE__*/React.createElement(Fragment, null, currentFilter && currentFilter.id !== 'deleted' ? /*#__PURE__*/React.createElement(StyledTh, {
    onClick: function onClick() {
      return handleSortClick('created');
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    style: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  }, t('signorders_list_th_created'), sortingField.field === 'created' ? /*#__PURE__*/React.createElement(SortIcon, {
    desc: sortingField.desc
  }) : null)) : /*#__PURE__*/React.createElement(StyledTh, null, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    style: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  }, t('signorders_list_th_autodelete'), sortingField.field === 'deletedAfter' ? /*#__PURE__*/React.createElement(SortIcon, {
    desc: sortingField.desc
  }) : null)), /*#__PURE__*/React.createElement(StyledTh, {
    className: "hideOnMobile",
    onClick: function onClick() {
      return handleSortClick('updated');
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, t('signorders_list_th_updated'), sortingField.field === 'updated' ? /*#__PURE__*/React.createElement(SortIcon, {
    desc: sortingField.desc
  }) : null)), /*#__PURE__*/React.createElement("th", {
    className: "hideOnMobile",
    style: {
      width: '5%'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: 'edit',
    size: "sm"
  }))) : null)), /*#__PURE__*/React.createElement(Tbody, null, paginated.map(function (order) {
    var _order$documents, _order$attachments, _order$signers;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: order.id
    }, /*#__PURE__*/React.createElement("tr", {
      onClick: handleExpandOrderClick(order.id),
      style: {
        cursor: 'pointer',
        backgroundColor: expandedOrder === order.id ? '#f6f6f6' : undefined
      }
    }, /*#__PURE__*/React.createElement(StyledTd, {
      style: {
        fontWeight: '700',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    }, /*#__PURE__*/React.createElement(Tooltip, {
      anchor: getOrderTitle(order),
      arrow: true
    }, getOrderTitle(order))), media.matches.tablet.and('up') ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Td, {
      textAlign: "center"
    }, ((_order$documents = order.documents) === null || _order$documents === void 0 ? void 0 : _order$documents.length) || 0), /*#__PURE__*/React.createElement(Td, {
      textAlign: "center"
    }, ((_order$attachments = order.attachments) === null || _order$attachments === void 0 ? void 0 : _order$attachments.length) || 0)) : null, media.matches.tablet.and('up') ? /*#__PURE__*/React.createElement(StyledTd, null, order && order.signers && order.signers.length ? /*#__PURE__*/React.createElement(Fragment, null, getRecipientName(order.signers[0]), order.signers.length > 1 ? " ".concat(t('recipients_and_n_more', {
      count: order.signers.length - 1
    })) : '') : "0 ".concat(t('signorder_term_recipients'))) : /*#__PURE__*/React.createElement(Td, {
      textAlign: "center"
    }, order !== null && order !== void 0 && (_order$signers = order.signers) !== null && _order$signers !== void 0 && _order$signers.length ? order.signers.length : '0'), /*#__PURE__*/React.createElement(StyledTd, {
      style: {
        color: '#fff'
      }
    }, /*#__PURE__*/React.createElement(Flex, {
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Status, {
      status: order.status,
      title: t(order.status)
    }, t(order.status)), (isOrderExpiring(order) || isOrderExpired(order)) && /*#__PURE__*/React.createElement(Tooltip, {
      anchor: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
        style: {
          marginLeft: '8px'
        },
        name: "announcementOutlined",
        color: "#f60000"
      }))
    }, isOrderExpiring(order) ? t('deletion_notification_helptext', {
      date: getExpirationDate(order)
    }) : t('deleted_notification_helptext')))), media.matches.tablet.and('up') ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Td, {
      className: "hideOnMobile"
    }, formatDate(currentFilter && currentFilter.id !== 'deleted' ? order.metaData.created : order.metaData.deletedAfter, 'dd.MM.yyyy')), /*#__PURE__*/React.createElement(Td, {
      className: "hideOnMobile"
    }, formatDate(order.metaData.lastUpdated, 'dd.MM.yyyy')), /*#__PURE__*/React.createElement(Td, {
      className: "hideOnMobile"
    }, getOrderIcon(order))) : null), expandedOrder === order.id ? media.matches.tablet.and('up') ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      colSpan: "8"
    }, /*#__PURE__*/React.createElement(SignOrderExpanded, {
      orderId: order.id,
      signOrder: order,
      collapse: function collapse() {
        setExpandedOrder(null);
      }
    }))) : /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      colSpan: "3"
    }, /*#__PURE__*/React.createElement(SignOrderExpanded, {
      orderId: order.id,
      signOrder: order,
      collapse: function collapse() {
        setExpandedOrder(null);
      }
    }))) : null);
  })))), /*#__PURE__*/React.createElement(CustomPagination, {
    currentPage: currentPage,
    totalPages: totalPages,
    totalItems: total,
    currentPageItems: paginated.length,
    setCurrentPage: handleChangePage,
    renderShowingString: function renderShowingString(currentPageCount, totalCount) {
      return t('signorders_list_pagination_showing', {
        currentPageCount: currentPageCount,
        totalCount: totalCount
      });
    },
    disabled: isLoading
  }), restoreOrder ? /*#__PURE__*/React.createElement(SignOrderRestore, {
    signOrder: restoreOrder,
    close: function close(restored) {
      return closeRestoreOrder(restored);
    }
  }) : null);
};
export default SignOrdersList;